import type { AnyWritableAtom } from 'components/scope-provider'
import { userAccountAtom } from 'context/account'
import { atom, useAtomValue, useSetAtom } from 'jotai'
import { loadable } from 'jotai/utils'
import { zeroAddress } from 'viem'
import { userHistoriesFactory } from '../../../../../services/query-v2/users/history/index'
import type { HeaderStorage, PortfolioReturns } from './interface'
import { getPortfolioReturnValues } from './services'

export const userProductHistoryAtom = userHistoriesFactory()
export const loadableUserProductHistory = loadable(userProductHistoryAtom.response)

const portfolioReturnsAtom = atom<PortfolioReturns>((get) => {
  const loadable = get(loadableUserProductHistory)
  if (loadable.state === 'hasError') {
    throw loadable.error
  }

  const userAddress = get(userAccountAtom)
  if (!userAddress || userAddress === zeroAddress) {
    return {
      investmentValue: undefined,
      investedCapital: undefined,
    }
  }

  if (loadable.state === 'hasData' && loadable.data !== null && userAddress !== zeroAddress) {
    const userHistory = loadable.data
    return getPortfolioReturnValues(userHistory)
  } else {
    return {
      investmentValue: undefined,
      investedCapital: undefined,
    }
  }
})

export const getHeaderStorage = (): HeaderStorage => {
  const userAddress = useAtomValue(userAccountAtom)

  const setUserAddressContractStatus = useSetAtom(userProductHistoryAtom.userAddress)
  setUserAddressContractStatus(userAddress ? userAddress : zeroAddress)
  return {
    portfolioReturns: useAtomValue(portfolioReturnsAtom),
  }
}

export const createHeaderStorage = (): [AnyWritableAtom, unknown][] => {
  const userAddress = useAtomValue(userAccountAtom)

  const response: [AnyWritableAtom, unknown][] = [[userProductHistoryAtom.userAddress, userAddress]]
  return response
}
